import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function OemSegmentNameCell({
  rowData: { sentinelTeam },
}: CellProps) {
  return <TextCell text={sentinelTeam?.oemSegment?.name} />;
}
